import { IApplicationState } from '../../types/redux';

export const selectOffers = ({ offers }: IApplicationState) => {
  return offers;
};
